import { ConfigProvider, theme } from 'antd';

/**
 * antd tema yapılandırması — TEK kaynak (App ve statik API'ler aynı nesneyi kullanır).
 *
 * v4'teki antd.compact.css'in v5 karşılığı: yoğunluk artık CSS değil tema algoritması.
 * Renkler marka token'larından (core/style/brand.css) gelir — antd'nin fabrika mavisi
 * (#1890ff) yerine slate birincil + amber uyarı. Böylece buton/link/seçim rengi header
 * ile aynı dili konuşur.
 */
export const antdTheme = {
    algorithm: theme.compactAlgorithm,
    token: {
        colorPrimary: '#34495E',
        colorLink: '#34495E',
        colorLinkHover: '#44607C',
        colorWarning: '#E0982A',
        // SEÇİLİ item zemini (dropdown/select option, date picker, cascader, menü) — antd
        // bunu colorPrimary'den türetirdi ve slate ile grimsi-mavi bir ton çıkıyordu.
        // Seçim de marka amber'i: grid'deki seçili satırla (Table.rowSelectedBg) aynı zemin.
        controlItemBgActive: '#F5DEB9',        // = --accent-row
        controlItemBgActiveHover: '#EFD3A8',
        // .ant-layout kendi zeminini basar (v5 varsayılanı #f5f5f5) ve body'yi örter
        // → marka nötrüne bağla, yoksa iki farklı gri yan yana görünür (bkz. --bg)
        colorBgLayout: '#F6F7F9',
        colorText: '#2C3E50',
        borderRadius: 6,
        fontFamily: "Manrope, 'Segoe UI', system-ui, -apple-system, sans-serif",
    },
    components: {
        // antd seçili satır zeminini colorPrimary'den türetiyor; slate primary ile
        // grimsi bir ton (#959b9e) çıkıyordu. Seçim marka amber'i olmalı.
        Table: {
            rowSelectedBg: '#F5DEB9',        // = --accent-row
            rowSelectedHoverBg: '#EFD3A8',
        },
    },
};

/**
 * Statik çağrılar — Modal.confirm/Modal.info/Modal.warning, message.*, notification.* — React
 * ağacının DIŞINDA, kendi köklerinde render edilir. Bu yüzden ConfigProvider'ı göremezler ve
 * antd'nin fabrika temasına düşerler (v5'in bilinen davranışı: "static function can not consume
 * context"). Onay modallarındaki birincil butonun mavi çıkmasının sebebi buydu — tema değil, kök farkı.
 *
 * holderRender o kökleri de aynı temaya sarar; onlarca çağrı yerini App.useApp()'e taşımak gerekmez.
 * Uygulama açılışında bir kez çağrılır (index.js).
 */
export function applyAntdThemeToStaticApis() {
    ConfigProvider.config({
        holderRender: (children) => (
            <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>
        ),
    });
}
